'use strict';

(function () {
  'use strict';

  angular.module('vnext').component('msInspirationCard', {
    bindings: {
      // The Inspiration Object
      inspiration: '<',
      enableActions: '<',
      mdInspirationCard: '<',
      absoluteSref: '@'
    },
    templateUrl: 'vnext/pages/inspirations/inspiration-card.html',
    controller: InspirationCardCtrl
  });
  InspirationCardCtrl.$inject = ['NotifyingSvc', 'inspirationSvc', '$translate', '$log'];

  function InspirationCardCtrl(NotifyingSvc, inspirationSvc, $translate, $log) {
    var vm = this;
    vm.openConfirmDeleteModal = openConfirmDeleteModal;
    vm.$onInit = function () {
      // vm.deleted is one-time bound in the template.
      // If vm.enableActions is false, vm.deleted will never change, so set it as false as well and the $watcher will be $destroyed.
      // If vm.enableActions is true, leave it as undefined and the $watcher will remain.
      // If vm.enableActions is left undefined, there will be a superfulous $watcher hanging around.
      vm.enableActions ? vm.deleted = undefined : vm.deleted = false;
      // Similarly, set this to empty string if it is undefined to prevent the creation of more $watchers.
      vm.absoluteSref = vm.absoluteSref || '';
      vm.mdInspirationCard = vm.mdInspirationCard || false;
    };

    function openConfirmDeleteModal() {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'vnext/templates/modal-confirm.html',
        controller: 'ConfirmModalCtrl',
        inputs: {
          heading: $translate.instant('vnext.inspirations.deleteModal.title'),
          body: [$translate.instant('vnext.inspirations.deleteModal.message-1'), $translate.instant('vnext.inspirations.deleteModal.message-2')],
          focusableId: '',
          deletionFlow: ''
        },
        closeCallback: function closeCallback(result) {
          if (result) {
            _deleteInspiration(vm.inspiration);
          }
        }
      });
    }

    function _deleteInspiration(inspiration) {
      inspirationSvc.delete(inspiration).then(function () {
        vm.deleted = true;
      }, function () {
        $log.error('Failed to delete inspiration.', inspiration);
      });
    }
  }
})();